export default "__VITE_ASSET__DCNGrty3__"